import _ from "lodash";

/**
 * @typedef {"UserRoles" | "UserStatus" | "Gender" | "Region"
 * | "Nationality" | "LoadingRate"} optionType
 * 
 * @typedef {Object} optionItem
 * @property {String} val
 * @property {lang} cap
 * @property {String} theme
 * @property {String} color
 */

class Options {

  /**
   * 
   * @typedef {import("IZOX/__typedef/common").lang} lang
   * @typedef {import("IZOX/__typedef/common").sysuserstatus} sysuserstatus
   */

  /**
   * 
   * @param {optionType} optionType 
   * @param {String} value 
   */
  static GetOptionList(optionType){
    switch(optionType){
      case "UserRoles": return this.__sysroles; 
      case "UserStatus": return this.__sysuserstatus; 
      case "Gender": return this.__gender;
      case "Region": return this.__region;
      case "Nationality": return this.__maidnationality;
      case "LoadingRate": return this.__loadingRate;
      default: return [];
    }
  }

  /**
   * 
   * @param {optionType} optionType 
   * @param {String} value 
   * @param {String} fallback 
   * @returns {optionItem}
   */
  static GetOption(optionType, value, fallback = undefined){
    let options = this.GetOptionList(optionType);
    return _.find(options, o => o.val === value)
      ?? _.find(this.__sysuserstatus, o => o.val === fallback);
  }

  /**
   * 
   * @type {optionItem[]}
   */
  static __loadingRate = [
    {val: 0, cap: "0%"},
    {val: 0.1, cap: "10%"},
    {val: 0.2, cap: "20%"},
    {val: 0.3, cap: "30%"},
    {val: 0.4, cap: "40%"},
    {val: 0.6, cap: "60%"},
    {val: 0.8, cap: "80%"},
    {val: 1.0, cap: "100%"},
    {val: 1.2, cap: "120%"},
    {val: 1.4, cap: "140%"},
    {val: 1.8, cap: "180%"},
    {val: 2.0, cap: "200%"},
    {val: 2.2, cap: "220%"}
  ]

  /**
   * 
   * @type {optionItem[]}
   */
  static __sysroles = [
    {val: "SYSDevs", cap: { EN: "SYSDevs", TC: "SYS開發者" }},
    {val: "Admin", cap: { EN: "Admin", TC: "管理員" }},
    {val: "Agent", cap: { EN: "Agent", TC: "代理" }},
    {val: "DCustomer", cap: { EN: "Direct Customer", TC: "直接客戶" }},
    {val: "Client", cap: { EN: "Agent's Client", TC: "代理客戶" }},
    {val: "Insurer", cap: { EN: "Insurer", TC: "保險公司" }},
    {val: "Internal", cap: { EN: "Internal", TC: "內部人員" }},
  ];

  /**
   * 
   * 
   * @type {optionItem[]}
   */
  static __sysuserstatus = [
    {val: "Active", cap: {EN: "Active", TC: "生效中"}, theme: "green"},
    {val: "Locked", cap: {EN: "Locked", TC: "封鎖中"}, theme: "purple"},
    {val: "Inactive", cap: {EN: "Inactive", TC: "失效中"}, theme: "red"},
    {val: "Applying", cap: {EN: "Applying (Data Problem)", TC: "申請中 (數據問題)"}, theme: "orange"},
    {val: "Verifying", cap: {EN: "Verifying (OTP Problem)", TC: "驗證 (OTP 問題)"}, theme: "orange"},
    {val: "Profiling", cap: {EN: "Profiling", TC: "填個人資料中"}, theme: "blue"},
    {val: "PendingToApprove", cap: {EN: "Waiting for Approval", TC: "等待審核中"}, theme: "yellow"},
    {val: "Deleted", cap: {EN: "Deleted", TC: "己刪除"}, theme: "red"},
    {val: "Rejected", cap: {EN: "Rejected", TC: "已拒絕"}, theme: "red"},
    {val: "__Unknown__", cap: {EN: "Unknown (Data Problem)", TC: "未知 (數據問題)"}, theme: "orange"}
  ];

  /**
   * 
   * 
   * @type {optionItem[]}
   */
  static __gender = [
    {cap: {EN: "M", TC: "男"}, val: "M"},
    {cap: {EN: "F", TC: "女"}, val: "F"}
  ];

  /**
   * 
   * 
   * @type {optionItem[]}
   */
  static __region = [
    {cap: {EN: "Kowloon City", TC: "九龍城"}, val: "klc"},
  ];

  static __maidnationality = [
    {cap: {EN: "Philippines", TC: "菲律賓"}, val: "philippines"},
    {cap: {EN: "Indonesia", TC: "印尼"}, val: "indonesia"}
  ];



}

export default Options;